import React from "react";
import { Check } from "lucide-react";

const FEATURES = [
  "Eigener Maschinenpark & Fuhrpark",
  "Festangestellte Fachkräfte aus der Region",
  "Termintreue durch eigene Bauleitung",
  "Transparente Kalkulation & Festpreisangebote",
  "Persönlicher Ansprechpartner — vom Erstgespräch bis zur Übergabe",
  "Generalunternehmer aus einer Hand",
];

export default function UeberUns() {
  return (
    <section
      id="ueber-uns"
      data-testid="ueberuns-section"
      className="bg-zinc-50 py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          {/* Image */}
          <div className="lg:col-span-6">
            <div className="relative aspect-[4/5] overflow-hidden bg-zinc-200">
              <img
                src="https://images.pexels.com/photos/33862076/pexels-photo-33862076.jpeg"
                alt="Bauingenieure auf der Baustelle"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          {/* Content */}
          <div className="lg:col-span-6">
            <div className="flex items-center gap-3 mb-6">
              <span className="w-12 h-px bg-red-600" />
              <span className="text-xs font-bold uppercase tracking-[0.3em] text-red-600">
                Über Honex
              </span>
            </div>

            <h2 className="font-display text-4xl sm:text-5xl md:text-6xl font-black uppercase tracking-tighter text-zinc-900 leading-[0.95]">
              Das Unternehmen mit{" "}
              <span className="text-red-600">Handschrift.</span>
            </h2>

            <div className="mt-8 space-y-5 text-zinc-700 text-base md:text-lg font-light leading-relaxed">
              <p>
                Honex GmbH steht für ehrliche Bauleistung. Aus langjähriger Erfahrung und
                einem klaren Qualitätsanspruch heraus hat sich das Unternehmen zu einem
                Generalunternehmer für Hochbau, Tiefbau und Industriebau entwickelt –
                mit Sitz in Essen, mitten im Ruhrgebiet.
              </p>
              <p>
                Bei uns ist der Bauleiter auch noch in zehn Jahren erreichbar. Unsere
                Stärke ist nicht der größte Marketingauftritt, sondern die Tatsache, dass
                Bauherren uns weiterempfehlen.
              </p>
              <p>
                Unser Team besteht aus <strong className="text-zinc-900 font-semibold">Handwerksmeistern</strong>,{" "}
                <strong className="text-zinc-900 font-semibold">Ingenieuren</strong> und{" "}
                <strong className="text-zinc-900 font-semibold">erfahrenen Polieren</strong> —
                eine Mannschaft, die das Bauen von der Pike auf gelernt hat und auf jeder
                Baustelle weiß, was zu tun ist.
              </p>
            </div>

            <ul className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-3">
              {FEATURES.map((f) => (
                <li
                  key={f}
                  className="flex items-start gap-3 text-sm text-zinc-800"
                >
                  <span className="w-5 h-5 bg-red-600 flex items-center justify-center mt-0.5 flex-shrink-0">
                    <Check className="w-3 h-3 text-white" strokeWidth={3} />
                  </span>
                  <span className="font-medium">{f}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
